import PresentationReducerBuilder from "./build-presentation-reducer"
import {
    USER_ITEM_REQUEST as ITEM_REQUEST,
    USER_ITEM_RESPONSE as ITEM_RESPONSE,
    USER_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    USER_ITEM_CACHED_RESPONSE as ITEM_CACHED_RESPONSE,
    USER_LIST_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    USERS_PAGE_LIST_REQUEST as LIST_PAGE_REQUEST,
    USERS_PAGE_LIST_RESPONSE as LIST_RESPONSE,
    USER_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    USER_SET_FILTER as SET_FILTER,
    USER_SET_EDIT_MODE as SET_EDIT_MODE,
    USER_UPDATE_FILTER_CRITERIA as UPDATE_FILTER_CRITERIA,
    USER_CLEAR_FILTER_CRITERIA as CLEAR_FILTER_CRITERIA,
    USER_UPDATE_IMAGE as UPDATE_IMAGE,
    USER_UPDATE_MODEL as UPDATE_MODEL,
    USER_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    USER_CANCEL_MODEL_UPDATE as CANCEL_MODEL_UPDATE,
    USER_ADD_NEW as ADD_NEW
} from "../../actions/action-types"

import {
    toUI as userToUI,
    updateUserChangeModel,
    updateUserCreateModel,
    UserModel,
    UserCreateModel
} from "../../models/entities/user"

import {
    UserFilterModel,
    updateUserSearchFilterModel
} from "../../models/filters/user-filter"

import { defaultSearchCriteria } from "../paging/user-paging-reducer"
import { serialiseSearchCriteria } from "../paging/paging-reducer-utils"

const reducerBuilder = new PresentationReducerBuilder()
export default reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        CANCEL_MODEL_UPDATE,
        CLEAR_FILTER_CRITERIA,
        UPDATE_FILTER_CRITERIA,
        SET_FILTER,
        SET_EDIT_MODE,
        ITEM_REQUEST,
        ITEM_RESPONSE,
        ITEM_SAVE_RESPONSE,
        ITEM_CACHED_RESPONSE,
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        ADD_NEW
    })
    .updateChangeModel(updateUserChangeModel)
    .updateCreateModel(updateUserCreateModel)
    .workingModelToUI(userToUI)
    .workingModelClass(UserModel)
    .workingFilterModelClass(UserFilterModel)
    .updateSearchFilterModel(updateUserSearchFilterModel)
    .canCancel(() => true)
    .createModelClass(UserCreateModel)
    .defaultState({
        workingModel: new UserModel(),
        searchCriteria: serialiseSearchCriteria(defaultSearchCriteria),
        searchFilterModel: defaultSearchCriteria,
        workingFilterModel: new UserFilterModel()
    })
    .build()
